module.exports = __webpack_public_path__ + "static/media/logo194.32590e56.png";